































import {Component, Watch, Mixins, Vue} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'
import {$, PageCollection, pushByName} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import {MixinSelect} from '@/components/mixins/MixinSelect'
import {AppConfig} from '@/config/app.config'
import Responsavel from '@/model/resource/Responsavel'
import TipoOcorrenciaSucesso from '../../model/resource/TipoOcorrenciaSucesso'

const metaInfo = () => ({
    title: $.t('view.manage.occurrenceSucessTypeList.title'),
})

@Component({
    metaInfo,
})
export default class ManageSucessOccurrenceTypeListView extends Mixins(MixinFilter, MixinSelect) {
    @Getter('auth/responsavel') user!: Responsavel

    AppConfig = AppConfig
    pushByName = pushByName

    collection = new PageCollection(TipoOcorrenciaSucesso, {}, 10)

    created() {
        this.collection.endpoint = '/user/tipo-ocorrencia-sucesso/responsavel'
    }
}
